import s from './AllPostedVideos.module.scss'
import { ReactComponent as IconArrow } from 'images/arrow-down-w.svg';
import useGetVideoCategories from 'sdk/hooks/salon/useGetVideoCategories';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface AllPostedVideosFilterProps {
  onCategoryChange: (categoryId: string) => void;
}

const AllPostedVideosFilter: React.FC<AllPostedVideosFilterProps> = ({ onCategoryChange }) => {
  const {t} = useTranslation() as any
  const { data: categories } = useGetVideoCategories();
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const handleCategorySelect = (categoryId: string) => {
    setSelectedCategory(categoryId);
    onCategoryChange(categoryId);
    setShowDropdown(false);
  };

  const getSelectedCategoryName = () => {
    if (selectedCategory === 'all') return t('All');
    return t(categories?.find(cat => cat.id === selectedCategory)?.name) || t('All');
  };

  return (
    <div className={s.all_videos_filter}>
      <div className={s.all_videos_filter_title}>{t('Category')}</div>
      <div className={s.all_videos_filter_selection} onClick={() => setShowDropdown(!showDropdown)}>
        <div className={s.all_videos_filter_selection_title}>
          {getSelectedCategoryName()}
        </div>
        <div className={s.all_videos_filter_selection_icon}>
          <IconArrow />
        </div>
      </div>

      {showDropdown && (
        <div className={s.dropdown_menu}>
          <div className={s.dropdown_item} onClick={() => handleCategorySelect('all')}>
            {t('All')}
          </div>
          {categories?.map((category) => (
            <div
              key={category.id}
              className={s.dropdown_item}
              onClick={() => handleCategorySelect(category.id)}
            >
              {category.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AllPostedVideosFilter; 